"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var PreloadApi_1 = require("../PreloadApi");
var PreloadableItemComponent = /** @class */ (function (_super) {
    __extends(PreloadableItemComponent, _super);
    function PreloadableItemComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasMoved = false;
        _this.videoRef = React.createRef();
        return _this;
    }
    PreloadableItemComponent.prototype.onClick = function () {
        this.props.onItemClick(this.props);
    };
    PreloadableItemComponent.prototype.playVideo = function () {
        this.videoRef.current.play();
    };
    PreloadableItemComponent.prototype.pauseVideo = function () {
        this.videoRef.current.pause();
    };
    PreloadableItemComponent.prototype.componentWillReceiveProps = function (newProps) {
        if ((0, PreloadApi_1.isVideo)(this.props.src)) {
            if (newProps.isCurrent && !this.props.isCurrent) {
                this.playVideo();
            }
            else if (!newProps.isCurrent && this.props.isCurrent) {
                this.pauseVideo();
            }
        }
    };
    PreloadableItemComponent.prototype.render = function () {
        var _this = this;
        var itemStyle = {
            width: this.props.width,
            height: this.props.height,
            display: 'inline-block',
            overflow: 'hidden'
        };
        var itemClass = this.props.isCurrent ? 'gallery-item js-current' : 'gallery-item';
        var renderResource = function (props) {
            var baseStyle = {
                width: '100%',
                height: '100%',
                MozUserSelect: 'none',
                backgroundColor: '#000',
                objectFit: 'cover',
                objectPosition: 'center',
                transition: 'all 0.3s linear'
            };
            var imgStyle = __assign(__assign({}, baseStyle), { pointerEvents: 'none' });
            var image = null;
            if (props.loaded) {
                image = props.src;
            }
            else if (props.preview) {
                image = props.thumb;
            }
            var text = props.text;
            if ((0, PreloadApi_1.isVideo)(props.src)) {
                return (React.createElement("video", { ref: _this.videoRef, src: props.src, style: baseStyle, autoPlay: false, loop: true }));
            }
            return (React.createElement("img", { src: image, style: imgStyle, alt: text }));
        };
        var dragup = function () {
            if (_this.hasMoved)
                return;
            _this.onClick();
        };
        var dragdown = function () {
            _this.hasMoved = false;
        };
        var dragmove = function () {
            _this.hasMoved = true;
        };
        var dragListeners = {
            onMouseUp: dragup,
            onMouseDown: dragdown,
            onMouseMove: dragmove,
            onTouchEnd: dragup,
            onTouchStart: dragdown,
            onTouchMove: dragmove
        };
        return (React.createElement("div", __assign({ className: itemClass, style: itemStyle }, dragListeners), renderResource(this.props)));
    };
    return PreloadableItemComponent;
}(React.PureComponent));
exports["default"] = PreloadableItemComponent;
